import { useState, useEffect } from 'react';

const getDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  const isDesktop = width >= 1025;
  const isTablet = width >= 710 && width <= 1024;
  const isLargeMobile = width >= 450 && width <= 709;
  const isSmallMobile = width <= 449;

  return {
    width,
    height,
    isDesktop,
    isTablet,
    isLargeMobile,
    isSmallMobile,
    isMobile: isSmallMobile || isLargeMobile,
  };
};

export const useViewport = () => {
  const [dimensions, setDimensions] = useState(getDimensions());

  useEffect(() => {
    const onResize = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return dimensions;
};
